import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

import queries from '@/graphql/dato/queries/index.js'

export const useDatoStore = defineStore('dato', () => {
  const { locale } = useI18n()
  const runtimeConfig = useRuntimeConfig()

  // Store state
  const seoFallback = ref({})
  const corporate = ref({})
  const navigation = ref({})

  // Store getters
  const configuration = computed(() => ({
    seoFallback: seoFallback.value,
    corporate: corporate.value
  }))

  // Store actions
  const fetchConfiguration = async () => {
    try {
      const { data } = await useAsyncQuery(queries.dato.datoState, {
        locale: locale?.value ? locale.value : 'it',
      })

      seoFallback.value = data.value?._site?.globalSeo || {}
      corporate.value = data.value?.corporate || {}
      navigation.value = data.value?.navigation || {}
    } catch (e) {
      console.error(e)
      seoFallback.value = {}
      corporate.value = {}
    }
  }

  return {
    seoFallback,
    corporate,
    navigation,
    configuration,
    fetchConfiguration,
  }
})
